import { SoundEffect } from "../music/SoundEffect";

export const playConnectionEffect = () => {
  new SoundEffect("start.mp3");
};
